import cx from 'classnames';
import React, { useState } from 'react';
import { Announcement, BotComp, Navbar, Sidebar, Spacer } from '../../components';

function Bot() {
  const [closeSide, setCloseSide] = useState(false)
  const [ann, setAnn] = useState(true)
  const toggleMenu = () => {
    if (closeSide) {
      setCloseSide(false)
    } else {
      setCloseSide(true)
    }
  }
  const classContentWrapper = cx({
    'scrollCustom': true,
    'contentWrapper': true,
    'wide': closeSide
  })

  return (
    <div className="page">
      <Navbar onClick={toggleMenu} closeSide={closeSide} />
      <div className="mainWrapper">
        <Sidebar closeSide={closeSide} />
        <div className={classContentWrapper}>
          <div className="container-fluid">
            <Spacer h={20} />
            <div className="cardContainer">
              <BotComp />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Bot

